<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-equip-class
            type="search"
            :isUtility="true"
            label="유틸리티"
            name="equipmentTypeCd"
            v-model="searchParam.equipmentTypeCd">
          </c-equip-class>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 점검년월(예정, 완료) -->
          <c-datepicker
            label="점검년월"
            name="month"
            type="month"
            v-model="searchParam.month">
          </c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 진행상태 -->
          <c-select
            type="search"
            stepperGrpCd="MIM_CHECK_STATUS_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="checkStatusCd"
            label="진행상태"
            v-model="searchParam.checkStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            :editable="editable"
            label="점검부서"
            type="search"
            name="checkDeptCd"
            v-model="searchParam.checkDeptCd">
          </c-dept>
        </div>
        <!-- 점검일 -->
        <!-- <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            name="period"
            label="점검완료일"
            v-model="period"
          ></c-datepicker>
        </div> -->
      </template>
    </c-search-box>
    
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(null,props.row)">
            <q-card-section horizontal class="bg-grey-2">
              <q-card-section class="q-pt-xs">
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.dailyName }}</div>
              </q-card-section>
            </q-card-section>
            <q-card-section class="grid-card-etc">
              <!-- <div class="text-grid-etc-title">
                라인 :
              </div>
              <div class="text-grid-etc">
                {{ props.row.lineCd }}
              </div> -->
              <div class="text-grid-etc-title">
                점검부서 :
              </div>
              <div class="text-grid-etc">
                {{ props.row.checkDeptName }}
              </div>
              <div :class="['text-grid-etc', getColorStatus(props.row.checkStatusCd)]">
                {{ props.row.checkStatusName }}
              </div>
              <div :class="['text-grid-etc', getColorStatus2(props.row.approvalStatusCd)]">
                {{ props.row.approvalStatusName }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
      <q-card class="mobileTableCardLayer">
        <q-card-section horizontal class="bg-grey-2 text-center">
          <q-card-section class="q-pt-xs">
            <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import mobileConfig from '@/js/mobileConfig';
export default {
  name: "equipment-utility_inspection",
  props: {
  },
  data() {
    return {
      grid: {
        columns: [
          // {
          //   name: "plantName",
          //   field: "plantName",
          //   style: 'width:100px',
          //   label: "사업장",
          //   align: "center",
          //   sortable: false,
          // },
          {
            name: "equipmentTypeNames",
            field: "equipmentTypeNames",
            style: 'width:150px',
            label: "유틸리티유형",
            align: "center",
            sortable: false,
          },
          {
            name: "dailyName",
            field: "dailyName",
            style: 'width:300px',
            label: "점검명",
            align: "left",
            type: "link",
            sortable: false,
          },
          {
            name: "checkDeptName",
            field: "checkDeptName",
            style: 'width:100px',
            label: "점검부서",
            align: "center",
            sortable: false,
          },
          {
            name: "checkStatusName",
            field: "checkStatusName",
            label: "진행단계",
            style: 'width:80px',
            align: "center",
            sortable: false,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: '결재진행단계',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: "checkDate",
            field: "checkDate",
            style: 'width:80px',
            label: "점검월",
            align: "center",
            sortable: false,
          },
          // {
          //   name: "checkUserName",
          //   field: "checkUserName",
          //   style: 'width:80px',
          //   label: "점검자",
          //   align: "center",
          //   sortable: false,
          // },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        month: '',
        lineId: '',
        utilityFlag: 'Y',
        checkDeptCd: '',
        equipmentTypeCd: null,
      },
      period: [ '', ''],
      editable: true,
      listUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
      selected: [],
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = selectConfig.sop.min.equipment.plan.daily.list.url;
      this.findResultUrl = mobileConfig.sop.min.equipment.result.daily.resultFind.url;
      // this.searchParam.checkDeptCd = this.$store.getters.user.deptCd
      this.searchParam.month = this.$comm.getThisMonth();
      if (this.$route.query.equipmentCd) {
        this.getDailyDetail();
      }
      this.getList();
    },
    getColorStatus(cd) {
      var cls = '';
      switch(cd) {
        case 'MCSC000005': // 계획수립
          cls = 'text-primary';
          break;
        case 'MCSC000010': // 점검중
          cls = 'text-positive';
          break;
        case 'MCSC000015': // 점검완료
          cls = 'text-orange-10';
          break;
        case 'MCSC000020': // 지연
          cls = 'text-red';
          break;
      }
      return cls;
    },
    getColorStatus2(cd) {
      var cls = '';
      switch(cd) {
        case 'ASC0000001': // 계획수립
          cls = 'text-primary';
          break;
        case 'ASC0000002': // 점검중
          cls = 'text-positive';
          break;
        case 'ASC9999999': // 점검완료
          cls = 'text-orange-10';
          break;
      }
      return cls;
    },
    getList() {
      // 전체조회
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getDailyDetail() {
      if (this.$route.query.equipmentCd) {
        this.$http.url = this.findResultUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          equipmentCd: this.$route.query.equipmentCd,
          checkDate: this.$comm.getToday(),
          utilityFlag: 'Y'
        };
        this.$http.request((_result) => {
          if (_result.data) {
            this.popupOptions.param = {
              dailyCheckId: _result.data.dailyCheckId,
              equipmentCd: this.$route.query.equipmentCd
            };
            this.popupOptions.title = _result.data.equipmentName + ' 유틸리티점검 결과'; 
            this.popupOptions.target = () =>
              import(`${"./equipmentQrUtilityDetail.vue"}`);
            this.popupOptions.visible = true;
            this.popupOptions.isFull = true;
            this.popupOptions.closeCallback = this.closePopup;
          } else {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '현재일 기준으로 작성된 유틸리티점검이 없습니다.',
              type: 'warning', // success / info / warning / error
            });
          }
        },);
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '존재하지 않는 설비입니다.',
          type: 'warning', // success / info / warning / error
        });
      }
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(evt, row) {
      this.popupOptions.param = {
        dailyCheckId: row ? row.dailyCheckId : '',
        title: '유틸리티점검'
      };
      this.popupOptions.title = row.dailyName; 
      this.popupOptions.target = () =>
        import(`${"./equipmentDailyDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    onItemClick(type) {
      this.linkClick(null, type);
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (type === 'COMPLETE' || type === 'SAVE') {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
      }
      this.getList();
    },
  },
};
</script>
<style>
.blinking {
  -webkit-animation:blink 3s ease-in-out infinite alternate;
  -moz-animation:blink 3s ease-in-out infinite alternate;
  animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@-moz-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
</style>